import { render, staticRenderFns } from "./TaahodatRiz.vue?vue&type=template&id=29819d66&scoped=true&"
import script from "./TaahodatRiz.vue?vue&type=script&lang=js&"
export * from "./TaahodatRiz.vue?vue&type=script&lang=js&"
import style0 from "./TaahodatRiz.vue?vue&type=style&index=0&id=29819d66&scoped=true&lang=css&"
import style1 from "./TaahodatRiz.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29819d66",
  null
  
)

export default component.exports